import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect, useRef, useCallback } from 'react';
import MetaTags from 'react-meta-tags';
import Paginator from 'react-hooks-paginator';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { connect } from 'react-redux';
import { getSortedProducts } from '../../helpers/product';
import LayoutOne from '../../layouts/LayoutOne';
import Breadcrumb from '../../wrappers/breadcrumb/Breadcrumb';
import ShopSidebar from '../../wrappers/product/ShopSidebar';
import ShopTopbar from '../../wrappers/product/ShopTopbar';
import ShopProducts from '../../wrappers/product/ShopProducts';
import HTMLFlipBook from 'react-pageflip';
import { Link } from "react-router-dom";
import Magnifier from "react-magnifier";

const CatalogFlip = ({ location, products }) => {
    const [layout, setLayout] = useState('grid three-column');
    const [sortType, setSortType] = useState('');
    const [sortValue, setSortValue] = useState('');
    const [filterSortType, setFilterSortType] = useState('');
    const [filterSortValue, setFilterSortValue] = useState('');
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [totPages, setTotPages] = useState(1000)
    //const [currentData, setCurrentData] = useState([]);
    const [sortedProducts, setSortedProducts] = useState([]);
    const pageLimit = 15;
    const { pathname } = location;
    const book = useRef();
    const getLayout = (layout) => {
        setLayout(layout)
    }

    const getSortParams = (sortType, sortValue) => {
        setSortType(sortType);
        setSortValue(sortValue);
    }

    const getFilterSortParams = (sortType, sortValue) => {
        setFilterSortType(sortType);
        setFilterSortValue(sortValue);
    }

    useEffect(() => {
        let sortedProducts = getSortedProducts(products, sortType, sortValue);
        const filterSortedProducts = getSortedProducts(sortedProducts, filterSortType, filterSortValue);
        sortedProducts = filterSortedProducts;
        setSortedProducts(sortedProducts);
        //setCurrentData(sortedProducts.slice(offset, offset + pageLimit));
    }, [offset, products, sortType, sortValue, filterSortType, filterSortValue]);

    const onKeyPressed = (e) => {
        if (book.current == null) return;
        if (e.keyCode == 37) book.current.pageFlip().flipPrev()
        if (e.keyCode == 39) book.current.pageFlip().flipNext()
    }
    useEffect(() => {
        document.addEventListener('keydown', onKeyPressed)
    }, [])
    const pagine = [...Array(186).keys()]
    var strings = require("../../translations/italian.json");

    const onFlip = useCallback((e) => {
        setCurrentPage(e.data)
        try {
            setTotPages(book.current.pageFlip().getPageCount() - 1)
        } catch (error) {
            
        }
        ////console.log('Current page: ' + e.data);
    }, []);

    return (
        <Fragment>
            <MetaTags>
                <title>{strings.catalog} | {strings.titleSite}</title>
                <meta
                    name="description"
                    content={strings.catalog + " " + strings.siteContent}
                />
            </MetaTags>

            <BreadcrumbsItem to={process.env.PUBLIC_URL + '/'}>Home</BreadcrumbsItem>
            <BreadcrumbsItem to={process.env.PUBLIC_URL + pathname}>Shop</BreadcrumbsItem>

            <LayoutOne headerTop="invisible" footerTop="invisible">

                <div className="shopping-cart-btn btn-hover text-center mt-20">
                    <a className="default-btn" style={{ marginBottom: "20px" }} href='/files/catalogoDGA.pdf'>
                        {strings["download_catalog"]}
                    </a>
                </div>


                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    {currentPage != 0 &&
                        <div className="shopping-cart-btn btn-hover text-center">
                            <Link className="default-btn" onClick={() => book.current.pageFlip().flipPrev()}>&lt;</Link>
                        </div>
                    }
                    <HTMLFlipBook
                        ref={book}
                        width={450}
                        height={650}
                        minWidth={315}
                        maxWidth={1000}
                        minHeight={400}
                        maxHeight={1533}
                        maxShadowOpacity={0.5}
                        showCover={true}
                        mobileScrollSupport={true}
                        className="demo-book"
                        onFlip={onFlip}
                        useMouseEvents={false}
                    >
                        {
                            pagine.map((pagine) => {
                                return (
                                    <div className="page" key={pagine} data-density="hard">
                                        <div className="page-content">
                                            <div className="page-image">
                                                {/*} <img
                                    className="animated img-fluid"
                                    src = {pagine.immagine}
                                    alt=""
                        /> */}
                                                <Magnifier src={"/assets/img/catalogo/ALL/catalogo-" + String(pagine).padStart(3, '0') + ".jpg"} mgWidth={300} mgHeight={300} mgShape={'square'} />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                    </HTMLFlipBook>
                    {currentPage != totPages && <div className="shopping-cart-btn btn-hover text-center">
                        <Link className="default-btn" onClick={() => book.current.pageFlip().flipNext()}>&gt;</Link>
                    </div>}
                </div>
                <div style={{ textAlign: "center" }}>
                    {currentPage == 0 && <p>Copertina</p>}
                    {currentPage != 0 && <p>Pagine {currentPage - 1}/{currentPage} di {totPages}</p>}
                </div>
            </LayoutOne>
        </Fragment>
    )
}

CatalogFlip.propTypes = {
    location: PropTypes.object,
    products: PropTypes.array
}

const mapStateToProps = state => {
    return {
        products: state.productData.products
    }
}

export default connect(mapStateToProps)(CatalogFlip);